import React from 'react';
import { ButtonWrapper, ProcessButtonWrapper, TabLineButton } from '../../../styles/button.style';
import usePostUpdateChemicalOrderStatus from '../../../api/usePostUpdateChemicalOrderStatus';
import { useTankCleaningStore } from '../../../context/TankCleaningContext';
import { useVesselStore } from '../../../context/VesselContext';
import { RoleTypeEnum } from '../../../enums/roleTypeEnum';
import { useAuthStore } from '../../../context/AuthContext';
import { ChemicalOrderStatus } from '../../../types/ViewModel/TankCleaning/Order/ChemicalOrderStatus';
import { ChemicalOrderStatusEnum } from '../../../enums/chemicalOrderStatusEnum';
import { Popconfirm } from 'antd';

const ProcessButtonManagerForOrderComponent: React.FC = () => {
    const { createChemicalOrderStatus } = usePostUpdateChemicalOrderStatus();
    const { selectedChemicalOrderForPortCall, chemicalOrderUpdateReportData } = useTankCleaningStore();
    const { selectedVessel } = useVesselStore();
    const { role } = useAuthStore();

    // ========== USE EFFECTS ===========

    const onUpdateChemicalOrderStatus = (chemicalOrderStatusEnum: ChemicalOrderStatusEnum) => {
        const chemicalOrderId = selectedChemicalOrderForPortCall?.chemicalOrderId;
        const orcaWebUrl = window.location.href;

        if (chemicalOrderStatusEnum && chemicalOrderId && selectedVessel && selectedVessel?.imoNumber) {
            const chemicalOrderStatus: ChemicalOrderStatus = {
                chemicalOrderStatusId: 0,
                chemicalOrderId: chemicalOrderId,
                orderStatusId: chemicalOrderStatusEnum,
                orcaWebUrl: orcaWebUrl,
                createdUtc: new Date(),
                createdBy: '',
                lastUpdatedUtc: new Date(),
                lastUpdatedBy: '',
            };

            createChemicalOrderStatus(chemicalOrderStatus, selectedVessel?.imoNumber);
        }
    };

    const showSendToOperatorButton = () => {
        if (chemicalOrderUpdateReportData && chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.Draft) {
            return (
                <TabLineButton onClick={() => onUpdateChemicalOrderStatus(ChemicalOrderStatusEnum.SentToOperator)}>Send to operator</TabLineButton>
            );
        }
    };

    const showCancelOrderButton = () => {
        if (
            (role.roleType === RoleTypeEnum.ShipUser &&
                chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.SentToOperator) ||
            ((role.roleType === RoleTypeEnum.ShipOperator || role.roleType === RoleTypeEnum.Admin) &&
                (chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.SentToOperator ||
                    chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.Ordered ||
                    chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.Confirmed))
        ) {
            return (
                <Popconfirm
                    okText="Yes"
                    cancelText="No"
                    title={'Are you sure you want to cancel order?'}
                    onConfirm={() => onUpdateChemicalOrderStatus(ChemicalOrderStatusEnum.Canceled)}
                >
                    <TabLineButton>Cancel order</TabLineButton>
                </Popconfirm>
            );
        }
    };

    const showOrderSentButton = () => {
        if (
            role &&
            (role.roleType === RoleTypeEnum.ShipOperator || role.roleType === RoleTypeEnum.Admin) &&
            chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.SentToOperator
        ) {
            return (
                <TabLineButton title="Order sent to vendor by OPS" onClick={() => onUpdateChemicalOrderStatus(ChemicalOrderStatusEnum.Ordered)}>
                    Order sent
                </TabLineButton>
            );
        }
    };

    const showConfirmOrderButton = () => {
        if (
            role &&
            (role.roleType === RoleTypeEnum.ShipOperator || role.roleType === RoleTypeEnum.Admin) &&
            chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.Ordered
        ) {
            return (
                <TabLineButton
                    title="Order confirmed delivery by vendor"
                    onClick={() => onUpdateChemicalOrderStatus(ChemicalOrderStatusEnum.Confirmed)}
                >
                    Order confirmed
                </TabLineButton>
            );
        }
    };

    return (
        <ButtonWrapper>
            {role && chemicalOrderUpdateReportData && chemicalOrderUpdateReportData.chemicalOrderItemList.length > 0 && (
                <ProcessButtonWrapper>
                    {showSendToOperatorButton()}
                    {showCancelOrderButton()}
                    {showOrderSentButton()}
                    {showConfirmOrderButton()}
                </ProcessButtonWrapper>
            )}
        </ButtonWrapper>
    );
};

export default ProcessButtonManagerForOrderComponent;
